<template>
	<div>
		<div class="main">
			<div v-if="!loading">
				<div class="w-full flex justify-start" v-if="!$route.params.processId">
					<div class="flex flex-col w-3/4 pr-0 md:pr-4">
						<BaseSelect
							class="w-1/2"
							v-if="damageCases"
							ref="license_plates"
							:disable-search="false"
							:label="$t('subject')"
							:options="damageCases"
							v-model="selectedDamageCase"
							track-by="id"
							:required="true"
							:multiple="false"
						/>
					</div>
				</div>

				<BaseInput v-model="chat.content" ref="BaseInput" :label="$t('message')" :required="true">
					<textarea ref="BaseInput" class="resize-y w-full shadow-m h-32" :placeholder="contentHint" v-model="chat.content"></textarea>
				</BaseInput>
			</div>
			<LoadingSpinner v-else />
		</div>
	</div>
</template>

<script>
import { ChatsApiFactory, CustomersApiFactory } from '@/api/generated';
import apiDefaults from '@/api/defaultConfiguration';
import BaseInput from '@/components/forms/inputs/BaseInput.vue';
import LoadingSpinner from '@/components/navigation/LoadingSpinner.vue';
import Validate from '@/mixins/Validate';
import BaseSelect from '@/components/forms/inputs/BaseSelect.vue';
import Authentication from '@/mixins/Authentication';
import { getDamageCaseLabel, getGermanDate } from '@/plugins/Utils';

export default {
	name: 'CreateChat',
	components: { BaseSelect, LoadingSpinner, BaseInput },
	mixins: [Validate, Authentication],
	data() {
		return {
			loading: true,
			damageCases: [],
			selectedDamageCase: null,
			contentHint: this.$t('message_placeholder'),
			customerID: null,
			chat: {
				damage_case_id: null,
				receiver_id: null,
				type: 'text',
				content: '',
			},
		};
	},
	methods: {
		save() {
			if (!this.validate()) {
				this.$swal(this.$t('general.attention').toString(), this.$t('please_check_input').toString(), 'warning');
				return;
			}
			this.chat.damage_case_id = this.selectedDamageCase.id;

			ChatsApiFactory(apiDefaults.config(), apiDefaults.basePath, apiDefaults.axios)
				.messagesPost(this.chat)
				.then(response => {
					this.$store.commit('setConfirmLeaving', false);
					this.$swal(this.$t('general.success').toString(), this.$t('message_sent').toString(), 'success').then(() => {
						if (this.$route.params.processId != null) {
							this.$store.dispatch('forceUpdateDamageCase', { id: parseInt(this.$route.params.processId) });
						} else {
							this.$root.$emit('updateChats');
						}
						this.$router.go(-1);
					});
				})
				.catch(error => {
					console.log(error);
					this.$swal(this.$t('general.error').toString(), this.$t('message_sent_error').toString(), 'error');
				});
		},
		getCustomerInformation() {
			const storedCustomer = this.$store.getters.getCustomer;
			if (storedCustomer != null) {
				this.chat.receiver_id = storedCustomer.id;
				this.contentHint = storedCustomer.companyName
					? `${this.$t('hello')} ${storedCustomer.companyName}...`
					: `${this.$t('hello')} ${storedCustomer.firstName} ${storedCustomer.lastName}...`;
				if (this.$route.params.processId != null) {
					this.selectedDamageCase = { id: this.$route.params.processId };
				} else {
					const damageCasesRaw = this.$store.getters.getDamageCases;
					damageCasesRaw.map(element => {
						this.damageCases.push({
							display: getDamageCaseLabel(element.processType, element.vehicle.licensePlate.text, getGermanDate(new Date(element.created_at * 1000))),
							id: element.id,
						});
					});
					this.damageCases.unshift({ display: this.$t('general_title'), id: 0 });
				}

				this.loading = false;
			} else {
				CustomersApiFactory(apiDefaults.config(), apiDefaults.basePath, apiDefaults.axios)
					.customersIdGet(this.customerID)
					.then(response => {
						if (this.$route.params.processId == null) {
							CustomersApiFactory(apiDefaults.config(), apiDefaults.basePath, apiDefaults.axios)
								.customersIdProcessesGet(this.customerID)
								.then(response => {
									response.data.data.map(element => {
										this.damageCases.push({
											display: getDamageCaseLabel(
												element.processType,
												element.vehicle.licensePlate,
												getGermanDate(new Date(element.created_at * 1000)),
											),
											id: element.id,
										});
									});
									this.damageCases.unshift({ display: this.$t('general_title'), id: 0 });
								})
								.catch(e => {
									this.$swal(this.$t('general.error').toString(), this.$t('error_occurred').toString(), 'error');
								});
						} else {
							this.selectedDamageCase = { id: this.$route.params.processId };
						}

						this.chat.receiver_id = response.data.id;
						this.contentHint = `${this.$t('hello')} ${response.data.firstName} ${response.data.lastName}...`;
						this.loading = false;
					})
					.catch(e => {
						this.$swal(this.$t('general.error').toString(), this.$t('error_occurred').toString(), 'error');
					});
			}
		},
	},
	mounted() {
		if (!this.isUserAllowedInLevel5or6) {
			this.$emit('authNotAllowed');
		} else {
			this.$store.commit('setConfirmLeaving', this.$t('leave_page'));
			this.customerID = this.$route.params.customerid;

			setTimeout(() => {
				this.getCustomerInformation();
			}, 1000);
		}
	},
};
</script>

<style scoped></style>
